

import { Link } from 'react-router-dom';
import { Settings, LogOut } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { usePermissions } from '@/contexts/unified-permissions';
import { OfflineAlertSyncButton } from '@/components/offline/ManualSyncControls';
import { useUserAvatar } from '@/hooks/useOfflineLogo';

export const SidebarUserFooter: React.FC = () => {
  const { user, signOut } = usePermissions();
  const { logoUrl: avatarUrl, isFromCache, isLoading, error } = useUserAvatar();

  if (!user) return null;
  
  return (
    <div className="border-t border-gray-200 p-4 space-y-3">
      <OfflineAlertSyncButton className="w-full" />
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <Link to="/profile" className="flex items-center">
            {isLoading ? (
              <div className="w-8 h-8 rounded-full bg-gray-200 animate-pulse" />
            ) : error ? (
              <img
                src="/lovable-uploads/aa1f7238-2168-4dae-8ddc-d3d93b7cc03d.png"
                alt="User Avatar"
                className="w-8 h-8 rounded-full object-cover"
                title={`Fallback avatar (${error})`}
              />
            ) : (
              <img
                src={avatarUrl}
                alt="User Avatar"
                className="w-8 h-8 rounded-full object-cover"
                title={isFromCache ? 'Cached avatar (offline ready)' : 'Online avatar'}
              />
            )}
          </Link>
          <div className="flex flex-col">
            <span className="text-sm font-medium text-gray-900">
              {user.user_metadata?.username || user.email?.split('@')[0]}
            </span>
            <span className="text-xs text-gray-600 truncate max-w-28">
              {user.email}
            </span>
          </div>
        </div>
        <div className="flex gap-1">
          <Button
            variant="ghost"
            size="icon"
            asChild
            className="text-gray-600 hover:text-gray-900 hover:bg-gray-100 h-8 w-8"
          >
            <Link to="/profile">
              <Settings className="w-4 h-4" />
            </Link>
          </Button>
          <Button
            variant="ghost"
            size="icon"
            onClick={signOut}
            className="text-gray-600 hover:text-gray-900 hover:bg-gray-100 h-8 w-8"
          >
            <LogOut className="w-4 h-4" />
          </Button>
        </div>
      </div>
    </div>
  );
};
